<template>
  <main>
    <CardInfo ref="cardInfo"/>
    <FilmList
      :has-card="hasCard"
      :card="card"
      :doctor="true"
      type="film"
      @checked="onChecked"
      @cancel="onCancel"/>
    <div class="fixed-bottom d-flex">
      <span
        class="flex-grow-1"
        style="background-color: #fff;"></span>
      <span
        v-show="checkedList.price !== checkedList.current_price"
        class="original-price">
        <del>问诊费用: {{ checkedList.price.toFixed(2) }} 元</del>
      </span>
      <span class="price">
        {{ checkedList.price === checkedList.current_price ? '问诊费用' : '推广价' }}:
        {{ checkedList.current_price.toFixed(2) }} 元
      </span>
      <van-button
        :disabled="checkedList.price <= 0 || checkedList.imageIds.length <= 0"
        type="danger"
        class="rounded-0"
        @click="handleOnSubmit">问诊</van-button>
    </div>
  </main>
</template>

<script>
import bus from '@/libs/bus';

const CardInfo = () => import('@/components/CardInfo.vue');
const FilmList = () => import('@/components/FilmList.vue');

export default {
  components: {
    CardInfo,
    FilmList,
  },
  data() {
    return {
      checkedList: {
        imageIds: '',
        price: 0,
        current_price: 0,
      },
      hasCard: false,
      hasList: false,
      card: {},
    };
  },
  mounted() {
    bus.$on('load-card', (status, value) => {
      this.hasCard = status;
      if (status) {
        this.card = value;
      }
    });
    bus.$on('load-list', (value) => {
      this.hasList = value;
    });
  },
  methods: {
    async handleOnSubmit() {
      const response = await this.$http.post('/cloud-film-api/webapi/order/insert', {
        imageId: this.checkedList.imageIds,
        doctorId: this.$route.params.id,
        // price: this.checkedList.current_price,
        // type: sessionStorage.getItem('report-type'),
        hospitalId: this.$refs.cardInfo.data.hospital_id,
      });
      const { id } = this.$route.params;
      window.location.href = `/cloud-film/doctor-payment/${id}?billCode=${response.order_code}`;
      sessionStorage.setItem('doctor_current_price', this.checkedList.current_price);
      sessionStorage.setItem('doctor_price', this.checkedList.price);
    },
    async onChecked(value) {
      this.checkedList.imageIds = value.patient_info.image_id;
      const response = await this.$http.get('/cloud-film-api/webapi/order/find-price', {
        imageId: this.checkedList.imageIds,
        doctorId: this.$route.params.id,
      });
      this.checkedList.current_price = response.current_price_yuan;
      this.checkedList.price = response.price_yuan;
      bus.$emit('clear_check', value.patient_info.image_id); // 清空check值
    },
    onCancel(value) {
      // 切换的时候不要清空
      if (value.patient_info.image_id === this.checkedList.imageIds) {
        this.checkedList.imageIds = '';
        this.checkedList.price = 0;
        this.checkedList.current_price = 0;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .price {
    background-color: #fff;
    line-height: 44px;
    padding-right: 12px;
    color: #f44;
    text-align: right;
  }

  .original-price {
    background-color: #fff;
    line-height: 44px;
    // font-size: 14px;
    text-align: right;
    padding-right: 4px;
  }
</style>
